module.exports = __webpack_public_path__ + "img/20_44.15c9b2ff.png";